import { Link } from "gatsby";
import React from "react";

interface HtmlNode {
  type: string;
  name?: string;
  attribs?: {
    [key: string]: string;
  };
  children?: HtmlNode[];
  data?: string;
}

export const transformLinks = (node: HtmlNode) => {
  if (node.type === "tag" && node.name === "a") {
    if (!node.attribs) return;
    if (!node.children) return;
    const { href } = node.attribs;
    const isRelativeLink =
      !href.startsWith("http://") && !href.startsWith("https://");

    if (isRelativeLink) {
      return <Link to={href}>{node.children[0].data}</Link>;
    }
    return (
      <a href={href} target={"_blank"} rel={"noreferrer"}>
        {node.children[0].data}
      </a>
    );
  }
};
